<template>
  <div @mouseleave="(contentIsVisible = false), (activeUtility = null)" class="wrapper mt-5 mt-md-0">
    <div
      class="activeLanguage"
      :style="{
        backgroundImage:
          'url(' + Object.values(activelanguage)[0]['iconUrl'] + ')',
      }"
    ></div>
    <div class="trigger" @click="toggleContentIsVisible">
      <i class="fal fa-cog"></i>
    </div>
    <div v-if="contentIsVisible" class="content" style="margin-top: -2px;">
      <div v-if="!activeUtility" class="utility-list">
        <p class="pointer" @click="activeUtility = 'languages'">
          {{ __("misc.language") }}
        </p>
         <p v-if="url_edit_password != null" class="pointer" @click="editPassword">
           {{ __("applicant.applicant.general.editPassword") }}
         </p>
         <p v-if="url_change_avatar != null " class="pointer" @click="editChangeAvatar">
           {{ __("applicant.applicant.general.editProfileImage") }}
         </p>
      </div>
      <div
        @click="activeUtility = null"
        v-if="activeUtility"
        class="text-right pr-3"
      >
        <i class="fal fa-chevron-left"></i>
      </div>
      <div v-if="activeUtility == 'languages'">
        <div v-for="language in languages" :key="language.slug">
          <a
            :href="'/setUserLanguage/' + language.id"
            class="cursor-pointer"
          >
            <div class="user-setting-utility row">
              <div class="col-3"><img :src="language.iconUrl" height="24px" width="24px" alt="" /></div>
              <div class="col-9">{{ language.label }}</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:
      {
        // "languages",
          languages : {
            type: Object,
            required: true,
          },
          activelanguage : {
            type: Object,
            required: true,
          },
          url_edit_password:{
            type: String,
            required : false,
            default : null
          },
          url_change_avatar:{
            type: String,
            required : false,
            default : null
          }

      },
  data() {
    return {
      contentIsVisible: false,
      activeUtility: null,
    };
  },
  methods: {
      toggleContentIsVisible() {
          this.contentIsVisible = !this.contentIsVisible;
      },
      editPassword(){
          app.__vue__.$refs.vue_popup.toggle(this.__("applicant.applicant.general.editPassword"),this.url_edit_password );
      },
      editChangeAvatar(){
          app.__vue__.$refs.vue_popup.toggle(this.__("applicant.applicant.general.editProfileImage"),this.url_change_avatar );
      },
  },
};
</script>

<style scoped>
.user-setting-utility :hover {
  font-style: italic;
}
.trigger {
  width: 24px;
  height: 24px;
  background: #f5f5f5;
  border-radius: 50%;
  border: 1px solid #e3e3e3;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: 8px;
}

.activeLanguage {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #e3e3e3;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  
  background-size: 40px;
  background-position: center;
}

.content {
  width: 220px;
  height: auto;
  border-radius: 10px;
  background: #f5f5f5;
  position: absolute;
  z-index: 1000;
  top: 100%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  padding: 4px;
}

.pointer {
  cursor: pointer;
}

.wrapper {
  position: relative;
  z-index: 99999;
  display: flex;
}
</style>
